import { Button } from "@/components/ui/button";
import { type ReactNode, useState } from "react";
import {
  Dialog,
  DialogTrigger,
  DialogTitle,
  DialogHeader,
  DialogContent,
} from "@/components/ui/dialog";
import { CreateTripForm } from "./create-trip-form";

interface CreateTripButtonProps {
  trigger?: ReactNode;
}

export function CreateTripButton({ trigger }: CreateTripButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  const onSuccess = () => {
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        {trigger ?? (
          <Button variant="default" title="Create New Trip">
            Create Trip
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogTitle>Create New Trip</DialogTitle>
        </DialogHeader>
        <CreateTripForm onSuccess={onSuccess} />
      </DialogContent>
    </Dialog>
  );
}
